import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import {
	BatchingStrategySymbol,
	LifeCycle,
	HeadContentSymbol,
	ComponentsStylesOverridesSymbol,
} from '@wix/thunderbolt-symbols'
import { RendererPropsProviderSym } from '.'
import { PageMountUnmountSubscriber } from './clientRenderer/pageMountUnmountSubscriber'
import { ClientBatchingStrategy } from './components/batchingStrategy'
import { ComponentsStylesOverrides } from './ComponentsStylesOverrides'
import { HeadContent } from './HeadContent'
import { RendererPropsProvider } from './RendererPropsProvider'

export const bindCommonSymbols: ContainerModuleLoader = (bind) => {
	bind(RendererPropsProviderSym).to(RendererPropsProvider)
	bind(BatchingStrategySymbol, LifeCycle.AppDidMountHandler).to(ClientBatchingStrategy)
	bind(HeadContentSymbol).to(HeadContent)
	bind(LifeCycle.AppWillLoadPageHandler).to(PageMountUnmountSubscriber)
	bind(ComponentsStylesOverridesSymbol).to(ComponentsStylesOverrides)
}
